<template>
  <div>
    <div class="col-xs-12">
      <div v-if="!hasChart">
        <spinner /> Desenhando os gráficos da estação. Por favor, aguarde...
      </div>
      {{ noChartWarning }}
      <div id="monitoringStation"></div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts"; //apex
import moment from "moment";

import { monitChart, stations } from "@/api";
import { organizeLog } from "@/pages/components/monit/charts";

// Barra de ET0 do dia atual, ainda em cálculo (não consolidado) — cor distinta da paleta normal.
const ET0_PARTIAL_COLOR = "rgba(140, 100, 40, 0.6)";

export default {
  name: "chart-station",
  props: {
    items: Array,
    nameStation: String,
    altitude: Number,
    anemometerHeight: Number,
    latitude: Number,
    longitude: Number,
    utc: [String, Number],
  },
  created() {
    this.controller = new AbortController();
    this.tryChart();
  },
  data() {
    return {
      controller: null,
      noChartWarning: "",
      hasChart: false,
      eqp: "SENSOR",
      charts: [],
      apexCharts: null,
      start: "",
      end: "",
    };
  },
  mounted() {
    this.apexCharts = document.getElementById("monitoringStation"); //apex
  },
  beforeDestroy() {
    if (this.charts.length) this.charts.forEach((e) => e.destroy()); //apex
    this.cancelActualRequestIfExists();
  },
  methods: {
    cancelActualRequestIfExists() {
      this.controller.abort();
    },
    tryChart() {
      this.hasChart = false;
      if (this.items && this.items.length) this.callChart();
      else {
        this.hasChart = true;
        this.noChartWarning =
          "Os equipamentos para o gráfico não foram identificados.";
      }
    },
    callChart() {
      this.emrSensor = this.items.filter((e) => e.INTERFACE == "EMR");
      let NAMES = [];
      let UNITS = [];
      let TYPES = [];
      this.emrSensor.map((e) => {
        NAMES.push(e.NAME);
        UNITS = [...UNITS, ...e.UNIT];
        TYPES = [...TYPES, ...e.TYPE];
      });
      let START = moment()
        .subtract(1, "week")
        .hours(0)
        .minutes(0)
        .format("YYYY-MM-DD HH:mm");
      let END = moment().format("YYYY-MM-DD HH:mm");
      this.start = START;
      this.end = END;
      // ET0 em paralelo com o fetch dos logs — não depende do /data-chart, some do caminho crítico.
      this._et0Promise = stations.calcEt0({
        from: START.split(" ")[0],
        to: END.split(" ")[0],
        granularity: "daily",
      });
      // let data = ;
      Promise.resolve({
        EQP: this.eqp,
        NAME: NAMES.filter((e, i, arr) => arr.indexOf(e) == i),
        COLUMN: "UNIT",
        CONDITION: {
          TYPES: TYPES.filter((e, i, arr) => arr.indexOf(e) == i),
          UNITS: UNITS.filter((e, i, arr) => arr.indexOf(e) == i),
        },
        START,
        END,
      })
        .then((data) => monitChart.create(data, this.controller))
        .then((ret) => {
          if (ret.status) {
            return organizeLog(ret, "STATION", NAMES);
          } else {
            alert(ret.log, "w");
            throw ret.log;
          }
        })
        .then((e) => {
          if (e.status) this.drawApexSyncCharts(e.value);
          else {
            this.hasChart = true;
            this.noChartWarning = e.log;
            alert(e.log, "w");
          }
        })
        .catch((err) => {
          this.hasChart = false;
          console.log(err);
        });
      // .then((_) => {

      //   this.hasChart = true;
      // });
    },
    //????
    calcLogsValue(logs) {
      let lastValue = Number(logs[logs.length - 1][1]);
      let newData = [];
      for (let [time, value] of logs) {
        let diff = Number(value) - lastValue;
        newData.push([time, diff.toFixed(2)]);
      }
      return newData;
    },
    drawApexSyncCharts(info) {
      //apex sync
      let color = [
        "rgba(255, 0, 0, 0.5)", //'red'
        "rgba(0, 0, 255, 0.5)", //'blue'
        "rgba(0, 255, 0, 0.5)", //'green'
        "rgba(0, 0, 0, 0.5)", //'black'
        "rgba(255, 0, 255, 0.5)", //'pink'
        "rgba(108, 117, 125, 0.5)", //'gray'
        "rgba(0, 255, 255, 0.5)", //'cyan'
        "rgba(255, 160, 0, 0.5)", //'orange'
        "rgba(160, 0, 255, 0.5)", //'purple'
        "rgba(0, 255, 160, 0.5)", //'teal'
      ];
      this.noChartWarning = "";
      let name = info.name;
      let count = 0;
      const formatMeasure = (measure) => {
        if (measure === "ALTURA PLUVIOMÉTRICA DIÁRIA") {
          return "PLUVIOMETRIA DIÁRIA";
        } else if (measure === "ALTURA PLUVIOMÉTRICA") {
          return "PLUVIOMETRIA";
        }
        return measure;
      };
      this.buildEt0Series(info).then((infoWithET0) => {
        // Estação sem leituras: organizeLog não cria as chaves de pluviometria
        const rain = infoWithET0["ALTURA PLUVIOMÉTRICA"];
        if (rain && rain.data) {
          rain.data = this.calcLogsValue(rain.data);
        }
        const rainDaily = infoWithET0["ALTURA PLUVIOMÉTRICA DIÁRIA"];
        if (
          rainDaily &&
          rainDaily.data.filter((e) => !!Number(e[1])).length
        )
          infoWithET0.typesPerSns.splice(
            infoWithET0.typesPerSns.indexOf("ALTURA PLUVIOMÉTRICA") + 1,
            0,
            "ALTURA PLUVIOMÉTRICA DIÁRIA"
          );
        let columns = infoWithET0.typesPerSns;
        let len = columns.length;
        for (let i = 0; i < len; i++) {
          let col = columns[i];
          let { data, type, measure, unit /*,  max, min */ } = infoWithET0[col];
          const isBar = ["ET0", "ALTURA PLUVIOMÉTRICA DIÁRIA", "P.M.F."].includes(
            col
          );
          // Barras = dados diários: eixo de categorias com um rótulo por dia (sem horas), centralizado
          // na barra e com todos os dias do intervalo mesmo sem valor. Linhas seguem com horário.
          const lineXaxis = {
            type: "datetime",
            labels: {
              datetimeUTC: false,
              format: "dd/MM/yyyy HH:mm",
              datetimeFormatter: {
                year: "yyyy",
                month: "MMM 'yy",
                day: "dd MMM",
                hour: "HH:mm",
              },
            },
          };
          let barXaxis = null;
          let seriesData = data;
          if (isBar) {
            const days = [];
            const cursor = moment(this.start).startOf("day");
            const lastDay = moment(this.end).startOf("day");
            while (cursor.isSameOrBefore(lastDay)) {
              days.push({
                key: cursor.format("YYYY-MM-DD"),
                label: cursor.format("DD/MM/YYYY"),
              });
              cursor.add(1, "day");
            }
            const tsOf = (p) => (Array.isArray(p) ? p[0] : p.x);
            const valOf = (p) => (Array.isArray(p) ? p[1] : p.y);
            const fillOf = (p) => (Array.isArray(p) ? undefined : p.fillColor);
            const byDay = new Map();
            (data || []).forEach((p) =>
              byDay.set(moment(tsOf(p)).format("YYYY-MM-DD"), p)
            );
            seriesData = days.map((d) => {
              const p = byDay.get(d.key);
              if (!p) return { x: d.label, y: null };
              const point = { x: d.label, y: valOf(p) };
              const fill = fillOf(p);
              if (fill) point.fillColor = fill;
              return point;
            });
            barXaxis = {
              type: "category",
              tickPlacement: "on",
              labels: { rotate: 0, hideOverlappingLabels: false },
            };
          }
          let opts = {
            chart: {
              id: `chart-${i}`,
              group: `monitoringEMR`,
              type: ["ET0", "ALTURA PLUVIOMÉTRICA DIÁRIA", "P.M.F."].includes(
                col
              )
                ? "bar"
                : "line",
              height: 260,
              width: "100%",
              animations: {
                enabled: false,
              },
              markers: {
                size: 0,
              },
              toolbar: {
                show: true,
                offsetX: 14,
                offsetY: -5,
                tools: {
                  download: true,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                  customIcons: [],
                },
                export: {
                  csv: {
                    headerCategory: `Horário`,
                    filename: "Dados do gráfico",
                    dateFormatter(timestamp) {
                      return moment(timestamp).format("DD/MM/YYYY HH:mm");
                    },
                  },
                },
              },
            },
            series: [
              {
                name: `${formatMeasure(measure)} (${unit})`,
                data: seriesData,
              },
            ],
            xaxis: isBar ? barXaxis : lineXaxis,
            responsive: [
              {
                breakpoint: 1000,
                options: {
                  plotOptions: {
                    bar: {
                      horizontal: false,
                    },
                  },
                  legend: {
                    position: "bottom",
                  },
                  stroke: {
                    curve: "smooth",
                    width: 2,
                  },
                  title: {
                    style: {
                      fontSize: "10px",
                    },
                  },
                  dataLabels: {
                    style: {
                      fontSize: "0.5rem",
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontWeight: "bold",
                      colors: ["#fff"],
                    },
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: "98%",
                    },
                  },
                  xaxis: isBar
                    ? { labels: { hideOverlappingLabels: true } }
                    : {
                        type: "datetime",
                        labels: {
                          format: "dd/MM/yyyy",
                          datetimeFormatter: {
                            year: "yyyy",
                            month: "MMM 'yy",
                            day: "dd MMM",
                          },
                          hideOverlappingLabels: true,
                        },
                      },
                },
              },
            ],
            legend: {
              position: "top",
              verticalAlign: "top",
              containerMargin: {
                left: 35,
                right: 60,
              },
            },

            title: {
              text: `${formatMeasure(measure)} (${unit})`,
              align: "left",
              offsetX: 0,
              offsetY: 15,
              margin: 10,
              style: {
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: undefined,
                color: "#263238",
                margin: 10,
                overflow: "hidden",
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "97%",
                dataLabels: {
                  position: "center",
                  maxItems: 100,
                  hideOverflowingLabels: true,
                  orientation: "horizontal",
                  fontSize: "5px",
                },
              },
            },

            colors: [color[count]],
            yaxis: {
              min: function (min) {
                return min < 0 ? min : 0;
              },
              max: function (max) {
                //Exibir máximo de 24 para eixo Y
                // caso for molhamento foliar
                if (col === "P.M.F.") {
                  return 24;
                } else if (max == 0) return 5;
                return max;
              },
              labels: {
                minWidth: 20,
                offsetY: -10,
                style: {
                  fontSize: "11px",
                },
              },
            },
            tooltip: {
              x: {
                show: false,
                format: isBar ? "dd/MM/yyyy" : "dd/MM/yyyy HH:mm",
              },
            },
          };

          let div = document.createElement("DIV");
          div.id = `chart-${i}`;
          if (col === "P.M.F.") {
            opts.yaxis.labels.formatter = (val) => {
              return val.toFixed(0);
              // return parseFloat(`${integer}.${Math.ceil(decimal*60)}`)
            };
            opts.yaxis.forceNiceScale = true;
          }
          this.apexCharts.appendChild(div);
          let chart = new ApexCharts(div, opts);
          this.charts.push(chart);
          chart.render();

          //to change next color
          if (count < 9) count++;
          else count = 0;
        }
        this.hasChart = true;
      });
    },
    buildEt0Series(info) {
      info.typesPerSns.splice(0, 0, "ET0");
      info.ET0 = {
        measure: "ET0 diária",
        type: "column",
        unit: "mm",
        max: "1000000",
        min: "-1000000",
        data: [],
      };
      const req =
        this._et0Promise ||
        stations.calcEt0({
          from: this.start.split(" ")[0],
          to: this.end.split(" ")[0],
          granularity: "daily",
        });
      return req
        .then((res) => {
          info.ET0.data = (res.daily || []).map((d) => {
            const point = {
              x: new Date(d.date + "T00:00:00").getTime(),
              y: Number(d.value).toFixed(2),
            };
            if (d.partial) point.fillColor = ET0_PARTIAL_COLOR;
            return point;
          });
          return info;
        })
        .catch((err) => {
          console.log(err);
          return info;
        });
    },
  },
};
</script>


<style scoped>
.chart-div {
  position: relative;
}
</style>
